import { createSerializer } from "src/serializers/serializer";

const EmptySerializer = createSerializer({});

export { EmptySerializer };
